<div class="latestVideosSection">
  <!-- travel videos -->
  <!-- <h1 class="text-center">{{ 'Be inspired' | translate }}</h1> -->
  <h2 class="homeHeadingSection">
    <span class="inter-font">{{ 'Be' | translate }}</span
    ><span class="cavet-font" style="margin-left: 10px">{{ 'Inspired' | translate }}</span>
  </h2>
  <!-- <h5 class="text-center homepage-desc">{{ 'LatestDesc' | translate }}</h5> -->
  <p class="homepage-desc latestVideosSectionP">{{ 'LatestDesc' | translate }}</p>
  <div>
    <!-- <div class="prevnextbtns prev mt-4 btncolor" (click)="prev()">
      <svg viewBox="0 0 13 20" xmlns="http://www.w3.org/2000/svg" aria-labelledby="title">
        <title>Previous</title>
        <polyline points="10,3 3,10 10,17"></polyline>
      </svg>
    </div>
    <div class="prevnextbtns next mt-4 btncolor" (click)="next()">
      <svg viewBox="0 0 13 20" xmlns="http://www.w3.org/2000/svg" aria-labelledby="title">
        <title>Next</title>
        <polyline points="10,3 3,10 10,17" transform="rotate(180 6.5,10)"></polyline>
      </svg>
    </div> -->
    <div class="latestvideos-flipster">
      <ul>
        <li *ngFor="let product of videoProducts" [id]="'q' + product.video">
          <div [id]="product.video" class="pvideos"></div>
        </li>
      </ul>
    </div>
    <div class="text-right hide-button">
      <button type="button" class="video-nav-button" aria-label="Navigate to previous youtubeVideo" (click)="prev()">
        <i class="pi pi-chevron-left"></i>
      </button>
      <button type="button" class="video-nav-button" aria-label="Navigate to next youtubeVideo" (click)="next()">
        <i class="pi pi-chevron-right"></i>
      </button>
    </div>
    <div class="text-center">
      <button
        type="button"
        *ngIf="isMobileLayout"
        class="video-nav-button"
        (click)="prev()"
        style="width: 80px; height: 30px"
      >
        <img class="img-fluid" src="../../assets/images/Arrow_Left.png" />
      </button>
      <button
        type="button"
        *ngIf="isMobileLayout"
        class="video-nav-button"
        (click)="next()"
        style="width: 80px; height: 30px"
      >
        <img class="img-fluid" src="../../assets/images/Arrow_Right.png" />
      </button>
    </div>
  </div>
</div>

<!-- travel videos-->
